import React, { useEffect, useRef, useState } from "react";

export default function Header({ scrollToContact,scrollToCourse }) {
  const textRef = useRef(null);
  const [isPaused, setIsPaused] = useState(false); // State to track pause
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const scrollContainer = textRef.current;
    let speed = 1; // Adjust speed as needed

    const scrollText = () => {
      if (!isPaused && scrollContainer) {
        scrollContainer.scrollLeft += speed;
        if (scrollContainer.scrollLeft >= scrollContainer.scrollWidth - scrollContainer.clientWidth) {
          scrollContainer.scrollLeft = 0;
        }
      }
    };
    const interval = setInterval(scrollText, 30);
    return () => clearInterval(interval);
  },[isPaused]);
  return (
    <>
    <header className="header-area header-sticky">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <nav className="main-nav">
              <a href="index.html" className="logo">
                <img src="./assets/images/logo-r.png" alt="Logo" className="logo-cls" />
              </a>

              <ul className="nav">
                <li className="scroll-to-section">
                  <a href="#top" className="active">Home</a>
                </li>
                <li><a href="#" onClick={(e) => { e.preventDefault(); setIsModalOpen(true); console.log("Modal Opened");}}>Online Class</a></li>
                {/* <li className="scroll-to-section"><a href="#apply">Apply Now</a></li> */}
                {/* <li className="has-sub">
                  <a href="#">Pages</a>
                  <ul className="sub-menu">
                    <li>
                      <a href="meetings.html">Upcoming Meetings</a>
                    </li>
                    <li>
                      <a href="meeting-details.html">Meeting Details</a>
                    </li>
                  </ul>
                </li> */}
                <li className="scroll-to-section"><a href="#" onClick={scrollToCourse}>Courses</a></li>
                <li className="scroll-to-section"><a href="#" onClick={scrollToContact}>Contact Us</a></li>
              </ul>
              <a className="menu-trigger">
                <span>Menu</span>
              </a>
            </nav>
          </div>
        </div>
      </div>
      <div style={{ overflow: "hidden", whiteSpace: "nowrap" }} ref={textRef} onMouseEnter={() => setIsPaused(true)} onMouseLeave={() => setIsPaused(false)}>
      <p style={{ display: "inline-block", minWidth: "1000px", color: "#38b2d8", fontSize:"20px", fontWeight:"bold"}}>
        Personalized Teaching  |  Customized Projects |  Teaching-Learning Optimal Ratio | Experienced Faculty | Remedial Class Support | Career Councelling
      </p>
    </div>
    </header>

    {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h2>Online Class Information</h2>
            <p>Join our interactive online classes and enhance your learning experience!</p>
            <button onClick={() => setIsModalOpen(false)}>Close</button>
          </div>
        </div>
      )}
      <style>
        {`
          .modal-overlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.5);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 999; /* Ensures modal is on top */
          }

          .modal-content {
            background: white;
            padding: 20px;
            border-radius: 8px;
            text-align: center;
            width: 300px;
          }

          .modal-content button {
            background: #ff5733;
            color: white;
            padding: 10px;
            border: none;
            cursor: pointer;
            margin-top: 10px;
          }

          .modal-content button:hover {
            background: #d84315;
          }
        `}
      </style>
    </>
  );
}
